<template>
    <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="Select Priority" hide-footer :centered="true" v-model="open">
        <b-form>
          <b-row>
            <b-col md="12">
                <gofix-form-dropdown
                    label="Priority"
                    vLabel="priority"
                    :reduce="option => option.id"
                    v-model="sla_id"
                    :options="slas">
                </gofix-form-dropdown>
            </b-col>
          </b-row>
        </b-form>

        <b-button-group class="d-block text-right">
          <gofix-button label="RAISE ISSUE" @click="save" noBorder :loading="loading"></gofix-button>
        </b-button-group>
    </b-modal>
</template>

<script>
    export default {
        name: 'modal_priority',
        components: {},
        props: {
            value: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            serviceCategoryId: {
                type: Number,
                default: false
            },   
        },
        data() {
            return {
                open: this.value,
                sla_id: null,
                slas: []
            }
        },
        mounted() {
            this.loadSLAByServiceCate();
        },
        created() {},
        watch: {
            open: function(val) {
                this.$emit('input', val);
            },
            value: function(val) {
                this.sla_id = null;
                this.open   = val;
            },
            serviceCategoryId: function(val) {
                this.slas = [];
                if(val) 
                    this.loadSLAByServiceCate();
            }
        },
        methods: {
            loadSLAByServiceCate(){
                if(!this.serviceCategoryId)
                    return;

                this.$store.dispatch("v2SlaController/getSlaList", {
                    limit:-1,
                    page:1,
                    filter: {
                        service_category_id: this.serviceCategoryId,
                    },
                }).then(response => {
                    this.slas = response.items;
                });
            },
            save() {
                if(!this.sla_id) {
                    return this.$alertNotification("Priority is required", "danger");
                }

                this.$emit('raise-issue', this.sla_id);
            }
        }
    }
</script>
